import { auth } from '@monorepo/utils/firebase'
import { EmailAuthProvider, signInWithEmailAndPassword as signInWithEmailAndPasswordFirebase } from '@monorepo/utils/firebase'
import { handleAuthWithCredential } from '../handleAuthWithCredential'

export const signInWithEmailAndPassword = async (payload: { email: string; password: string }) => {
  const currentUser = auth().currentUser

  if (currentUser && currentUser.isAnonymous) {
    // If anonymous, attempt to link the credentials
    const credential = EmailAuthProvider.credential(payload.email, payload.password)

    const result = await handleAuthWithCredential(
      credential,
      () => signInWithEmailAndPasswordFirebase(auth(), payload.email, payload.password),
      payload.email
    )

    return {
      provider: 'email',
      user: result,
    }
  } else {
    // Normal flow - sign in with email and password
    const user = await signInWithEmailAndPasswordFirebase(auth(), payload.email, payload.password)
    return {
      provider: 'email',
      user,
    }
  }
}
